const CHECKOUT_PLAN_KEY = "learnweb_checkout_plan";

export interface CheckoutPlan {
  id?: number;
  name: string;
  price: string;
  priceValue: number;
  period: string;
  features: string[];
  summaryTitle: string;
  billingDescription: string;
}

export function setCheckoutPlan(plan: CheckoutPlan): void {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(CHECKOUT_PLAN_KEY, JSON.stringify(plan));
}

export function getCheckoutPlan(): CheckoutPlan | null {
  if (typeof window === "undefined") {
    return null;
  }

  const rawPlan = window.localStorage.getItem(CHECKOUT_PLAN_KEY);
  if (!rawPlan) {
    return null;
  }

  try {
    return JSON.parse(rawPlan) as CheckoutPlan;
  } catch {
    return null;
  }
}
